import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TaskMaintenanceIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            d='M18.3723 2.3681C16.362 1.60458 14.0024 2.02788 12.3834 3.64694C10.6942 5.33607 10.302 7.83274 11.2056 9.89619L2.60189 18.4999C1.79937 19.3024 1.79937 20.5953 2.60189 21.3977C3.40442 22.2002 4.69728 22.2002 5.49968 21.3977L14.1034 12.794C16.1677 13.6986 18.6634 13.3063 20.3526 11.6162C21.9717 9.99712 22.396 7.63762 21.6315 5.62721L18.7216 8.53703C17.8181 9.44062 16.3641 9.44062 15.4614 8.53703C14.5578 7.63345 14.5578 6.17948 15.4614 5.27677L18.3712 2.36694L18.3723 2.3681Z'
        />
    ),
})

TaskMaintenanceIcon.displayName = 'TaskMaintenanceIcon'
